import { createContext, useContext } from 'react'
import { useStore } from 'zustand'
import type { StoreApi } from 'zustand'
import type { LayoutStoreState } from './store'

type LayoutStore = StoreApi<LayoutStoreState>

export const LayoutStoreContext = createContext<LayoutStore | null>(null)

export function useLayoutStore<T>(selector: (state: LayoutStoreState) => T): T {
  const store = useContext(LayoutStoreContext)
  if (!store) throw new Error('useLayoutStore must be used within LayoutStoreProvider')
  return useStore(store, selector)
}

export function useLayoutStoreApi(): LayoutStore {
  const store = useContext(LayoutStoreContext)
  if (!store) throw new Error('useLayoutStoreApi must be used within LayoutStoreProvider')
  return store
}
